export default __webpack_public_path__ + "static/media/background.71182e8a.jpg";